import { createBrowserRouter } from "react-router-dom";
import Player from "./pages/Player";
import ProtectedRoutes from "./utils/ProtectedRoutes";
import TicketPage from "./pages/TicketPage";
import Overview from "./pages/Overview";
import MainPage from "./pages/MainPage";
import Feedback from "./pages/Feedback";
import Introduction from "./pages/Introduction";
import NoMatch from "./pages/NoMatch";

export const router = createBrowserRouter([
  { path: "/", element: <Introduction /> }, /* /introduction */
  {
    path: "/player",
    element: (
      <ProtectedRoutes>
        <Player />
      </ProtectedRoutes>
    ),
  },
  {
    path: "/overview",
    element: <Overview />,
  },
  {
    path: "/ticket",
    element: <TicketPage />,
  },
  {
    path: "/feedback",
    element: <Feedback />
  },
  {
    path: "*",
    element: <NoMatch />,
  },
]);
